import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { StoreProvider } from "@/lib/store";
import { initAnalytics, trackPageview } from "@/lib/analytics";
import AppShell from "@/components/AppShell";
import HomePage from "@/pages/HomePage";
import CategoryPage from "@/pages/CategoryPage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderSuccessPage from "@/pages/OrderSuccessPage";
import AccountPage from "@/pages/AccountPage";
import AddressesPage from "@/pages/AddressesPage";
import TransactionsPage from "@/pages/TransactionsPage";
import TransactionDetailPage from "@/pages/TransactionDetailPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import HelpPage from "@/pages/HelpPage";
import SearchPage from "@/pages/SearchPage";
import MessagesPage from "@/pages/MessagesPage";
import MessageDetailPage from "@/pages/MessageDetailPage";
import "@/index.css";

// Loads GA4 once (if REACT_APP_GA4_ID is set) and reports a page_view on every
// route change — SPAs must send these manually.
function AnalyticsTracker() {
  const loc = useLocation();
  useEffect(() => { initAnalytics(); }, []);
  useEffect(() => { trackPageview(loc.pathname + loc.search); }, [loc.pathname, loc.search]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <StoreProvider>
        {/* basename follows PUBLIC_URL so subpath deploys (e.g. /v2) route correctly */}
        <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
          <AnalyticsTracker />
          <Toaster richColors position="top-center" toastOptions={{ duration: 2500 }} />
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/category/:id" element={<CategoryPage />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/order/success" element={<OrderSuccessPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/account/addresses" element={<AddressesPage />} />
              <Route path="/account/transactions" element={<TransactionsPage />} />
              <Route path="/account/transactions/:id" element={<TransactionDetailPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/messages" element={<MessagesPage />} />
              <Route path="/messages/:branchId" element={<MessageDetailPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </StoreProvider>
    </AuthProvider>
  );
}

export default App;
